/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Form_Gps_SectionInputs */

const vi_vehicle_form_gps_section = /** @type {(inputs: Vehicle_Form_Gps_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấu hình GPS`)
};

/**

* @param {Vehicle_Form_Gps_SectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_form_gps_section = /** @type {((inputs?: Vehicle_Form_Gps_SectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Form_Gps_SectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_form_gps_section(inputs)
});